import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '../auth/AccessTokenContext';
import { getApiV1Scenariotemplates } from '../api/generated';
import { queryKeys } from './queryKeys';

export const useFetchScenarioTemplates = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.scenarioTemplates(),
    queryFn: () => getApiV1Scenariotemplates({}),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
